export enum GameId {
  WinterSports = 1,
  SummerSports = 2,
}
